import { Button, ButtonProps } from '@mui/material';
import { omit } from 'lodash';

import { label3 } from '~components/theme/typography';

export const SmolButton: React.FC<ButtonProps> = ({ sx, children, ...props }) => (
  <Button sx={{ borderRadius: '6px', ...omit(label3, 'color'), ...sx }} {...props}>
    {children}
  </Button>
);
